import React, { useContext, useState } from 'react';
import ScocialLogin from '../Share/SocialLogin/ScocialLogin';
import toast from 'react-hot-toast';
import { useForm } from "react-hook-form";
import { AuthContext } from '../../../contex/AuthProvider';
import { Link, useNavigate } from 'react-router-dom';

const Signup = () => {
    const { register, formState: { errors }, handleSubmit } = useForm();
    const { updateUser, createUser, setUserType } = useContext(AuthContext);
    const [signUpError, setSignUPError] = useState('');
    const navigate = useNavigate();

    const handleSignup = data => {
        setSignUPError('');
        console.log(data);
        createUser(data.email, data.password)
            .then(result => {
                const user = result.user;
                console.log(user);
                toast.success('User Created Successfully.')
                const userInfo = {
                    displayName: data.name
                }
                updateUser(userInfo)
                    .then(() => {
                        saveUser(data.name, data.email, data.userType);
                    })
                    .catch(err => console.error(err));
            })
            .catch(error => {
                console.error(error)
                setSignUPError(error.message)
            });
    }
    const saveUser = (name, email, userType) => {
        const user = { name, email, userType, isVerify: false };
        fetch('https://assignment-12-server-beige.vercel.app/users', {
            method: 'POST',
            headers: {
                'content-type': 'application/json'
            },
            body: JSON.stringify(user)
        })
            .then(res => res.json())
            .then(data => {
                // setCreatedUserEmail(email);
                setUserType(userType);
                TakeToken(email);
                // console.log(data)
            })
    }
    const TakeToken = email => {
        fetch(`https://assignment-12-server-beige.vercel.app/jwt?email=${email}`)
            .then(res => res.json())
            .then(data => {
                if (data.accessToken) {
                    localStorage.setItem('accessToken', data.accessToken);
                    navigate('/')
                }
            })
    }


    return (
        <div className="hero w-full my-16">
            <div className="hero-content gap-12 grid md:grid-cols-2 flex-col lg:flex-row">

                <div className="text-center lg:text-left ml-4">

                    <img className='w-3/4 ml-6' src='https://speechtext.ai/static/img/signup-image.png' alt="" />
                </div>
                <div className='h-[800px]  flex justify-center items-center'>
                    <div className=' w-96 p-7'>
                        <h2 className='text-center text-4xl'>Sign Up</h2>
                        <form onSubmit={handleSubmit(handleSignup)}>


                            <div className="form-control w-full max-w-xs">
                                <label className="label"><span className="label-text">Name</span></label>
                                <input type="text" {...register("name", {
                                    required: "Name is required"
                                })} className="input input-bordered w-full max-w-xs" />
                                {errors.name && <p className='text-red-600'>{errors.name?.message}</p>}
                            </div>
                            <div className="form-control w-full max-w-xs">
                                <label className="label"><span className="label-text">Email</span></label>
                                <input type="email" {...register("email", {
                                    required: "Email Address is required"
                                })} className="input input-bordered w-full max-w-xs" />
                                {errors.email && <p className='text-red-600'>{errors.email?.message}</p>}
                            </div>
                            <div className="form-control w-full max-w-xs mb-2">
                                <label className="label"> <span className="label-text">Password</span></label>
                                <input type="password" {...register("password", {
                                    required: "Password is required",
                                    minLength: { value: 6, message: 'Password must be 6 characters or longer' },
                                    pattern: { value: /(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])/, message: 'Password must have uppercase, number and special characters like as  Imr123#' }

                                })} className="input input-bordered w-full max-w-xs" />
                                {errors.password && <p className='text-red-600'>{errors.password?.message}</p>}


                            </div>
                            <div className='form-control w-full max-w-xs mb-3'>
                                <label className="label"> <span className="label-text">User Type</span></label>
                                <select type='text' {...register("userType", {
                                    required: 'User Type is required'
                                })} className="select select-bordered w-full max-w-xs">

                                    <option value={'seller'}>Seller</option>
                                    <option value={'buyer'}>Buyer </option>
                                </select>
                                {errors.userType && <p className='text-red-600'>{errors.userType?.message}</p>}
                            </div>
                            <input className='btn btn-accent w-full mt-2' value='Sign Up' type="submit" />
                            {signUpError && <p className='text-red-600'>{signUpError}</p>}
                        </form>
                        <p className='text-1xl mt-2'>already have a account ?<Link className='text-secondary' to='/login'> Please Login</Link>
                        </p>
                        <div className="divider">OR</div>
                        <ScocialLogin></ScocialLogin>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Signup;